// Phase 2 — Sélection IA des activités BTP à VALIDER par l'humain.
// Détecte `?from=ia_activites&ia_membre=<id>`, interroge l'IA (Claude) et
// pré-sélectionne les activités + le CA dans le simulateur BATICO. Aucun
// calcul automatique : l'humain vérifie/ajuste puis calcule manuellement.
import { useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { getToken } from '../../services/tokenService';
import { API } from './constants';

export function useIaActivitesPrefill(deps) {
  const {
    location, autoCalcDoneRef, setFormData,
    setSelectedActivitesGO, setSelectedActivites2nd, setSelectedActivitesTP, setSelectedActivitesPIB,
  } = deps;

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('from') !== 'ia_activites') return;
    const iaMembre = params.get('ia_membre');
    if (!iaMembre) return;
    if (autoCalcDoneRef) autoCalcDoneRef.current = true;
    let cancelled = false;
    (async () => {
      const token = getToken();
      if (!token) return;
      const tid = toast.loading('Sélection IA des activités en cours…');
      try {
        const res = await axios.post(
          `${API}/domium-ia/suggest-activites`,
          { membre_id: iaMembre },
          { headers: { Authorization: `Bearer ${token}` } },
        );
        if (cancelled) return;
        const s = res.data?.suggestions || {};
        if (Array.isArray(s.gros_oeuvre) && s.gros_oeuvre.length) setSelectedActivitesGO(s.gros_oeuvre);
        if (Array.isArray(s.second_oeuvre) && s.second_oeuvre.length) setSelectedActivites2nd(s.second_oeuvre);
        if (Array.isArray(s.travaux_publics) && s.travaux_publics.length) setSelectedActivitesTP(s.travaux_publics);
        if (Array.isArray(s.intellectuels) && s.intellectuels.length) setSelectedActivitesPIB(s.intellectuels);
        if (res.data?.ca_ht) {
          setFormData(prev => (prev?.ca_ht && String(prev.ca_ht).trim() !== '')
            ? prev : { ...prev, ca_ht: String(res.data.ca_ht) });
        }
        toast.dismiss(tid);
        toast.success(
          `Sélection IA appliquée (${res.data?.nombre_suggerees || 0} activités). Vérifiez et ajustez avant de calculer la contribution.`,
          { duration: 9000 },
        );
      } catch (err) {
        toast.dismiss(tid);
        toast.error(err?.response?.data?.detail || 'Erreur suggestion IA des activités');
      }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line
  }, [location.search]);
}

export default useIaActivitesPrefill;
